import { checkAndUpdateToken } from "./auth";
import { BACKEND_URL_PREFIX } from "../utils/const";
import { buildDefaultHeaders } from "./helper";
import { createNotification } from "../components/notifications/notifications";
import * as types from './types';

// ============ BUTTONS ============

export const getButtons = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: types.SET_INFO_KIOSK_BUTTONS_LOADING, payload: true });
  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/info_kiosk/buttons`,
      buildDefaultHeaders(getState)
    );
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: types.SET_INFO_KIOSK_BUTTONS, payload: data });
    } else {
      createNotification('error', 'Ошибка загрузки кнопок');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_INFO_KIOSK_BUTTONS_LOADING, payload: false });
  }
};

export const saveButtons = (buttons) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: types.SET_INFO_KIOSK_BUTTONS_LOADING, payload: true });
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/info_kiosk/buttons`, {
      method: "PUT",
      body: JSON.stringify(buttons),
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      dispatch({ type: types.SET_INFO_KIOSK_HAS_CHANGES, payload: false });
      createNotification('success', 'Кнопки сохранены');
      dispatch(getButtons());
    } else {
      const data = await response.json();
      createNotification('error', data.error || 'Ошибка сохранения');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_INFO_KIOSK_BUTTONS_LOADING, payload: false });
  }
};

export const resetButtonsToDefaults = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: types.SET_INFO_KIOSK_BUTTONS_LOADING, payload: true });
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/info_kiosk/buttons/reset`, {
      method: "POST",
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      createNotification('success', 'Подписи сброшены к значениям по умолчанию');
      dispatch(getButtons());
    } else {
      createNotification('error', 'Ошибка сброса');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_INFO_KIOSK_BUTTONS_LOADING, payload: false });
  }
};

// ============ SCREENSAVER FILES ============

export const getScreensaverFiles = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: types.SET_INFO_KIOSK_FILES_LOADING, payload: true });
  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/info_kiosk/screensaver/files`,
      buildDefaultHeaders(getState)
    );
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: types.SET_INFO_KIOSK_FILES, payload: data });
    } else {
      createNotification('error', 'Ошибка загрузки файлов');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_INFO_KIOSK_FILES_LOADING, payload: false });
  }
};

export const uploadScreensaverFile = (file) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  const formData = new FormData();
  formData.append("file", file);

  dispatch({ type: types.SET_INFO_KIOSK_FILE_UPLOADING, payload: true });
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/info_kiosk/screensaver/files`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Basic ${btoa(`${getState().auth.token}:empty`)}`
      },
      body: formData
    });
    if (response.ok) {
      createNotification('success', 'Файл загружен');
      dispatch(getScreensaverFiles());
    } else {
      const data = await response.json();
      createNotification('error', data.error || 'Ошибка загрузки файла');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_INFO_KIOSK_FILE_UPLOADING, payload: false });
  }
};

export const deleteScreensaverFile = (fileId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: types.SET_INFO_KIOSK_FILES_LOADING, payload: true });
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/info_kiosk/screensaver/files/${fileId}`, {
      method: "DELETE",
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      createNotification('success', 'Файл удалён');
      dispatch(getScreensaverFiles());
    } else {
      const data = await response.json();
      createNotification('error', data.error || 'Ошибка удаления');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_INFO_KIOSK_FILES_LOADING, payload: false });
  }
};

export const updateScreensaverFile = (fileId, data) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/info_kiosk/screensaver/files/${fileId}`, {
      method: "PATCH",
      body: JSON.stringify(data),
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      dispatch(getScreensaverFiles());
    } else {
      const result = await response.json();
      createNotification('error', result.error || 'Ошибка обновления');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  }
};

export const updateFilesOrder = (files) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/info_kiosk/screensaver/files/order`, {
      method: "PUT",
      body: JSON.stringify(files),
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      dispatch(getScreensaverFiles());
    } else {
      const data = await response.json();
      createNotification('error', data.error || 'Ошибка сохранения порядка');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  }
};

// ============ SCREENSAVER SETTINGS ============

export const getScreensaverSettings = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: types.SET_INFO_KIOSK_SETTINGS_LOADING, payload: true });
  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/info_kiosk/screensaver/settings`,
      buildDefaultHeaders(getState)
    );
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: types.SET_INFO_KIOSK_SETTINGS, payload: data });
    } else {
      createNotification('error', 'Ошибка загрузки настроек');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_INFO_KIOSK_SETTINGS_LOADING, payload: false });
  }
};

export const saveScreensaverSettings = (settings) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: types.SET_INFO_KIOSK_SETTINGS_LOADING, payload: true });
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/info_kiosk/screensaver/settings`, {
      method: "PUT",
      body: JSON.stringify(settings),
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      createNotification('success', 'Настройки сохранены');
      dispatch(getScreensaverSettings());
    } else {
      const data = await response.json();
      createNotification('error', data.error || 'Ошибка сохранения настроек');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_INFO_KIOSK_SETTINGS_LOADING, payload: false });
  }
};

// ============ LOCAL STATE ============

export const setHasChanges = (value) => ({
  type: types.SET_INFO_KIOSK_HAS_CHANGES,
  payload: value
});
